<script setup>
import {onBeforeUnmount, onBeforeMount, ref} from "vue";
import { useStore } from "vuex";

import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonCheckbox from "@/components/ArgonCheckbox.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Cookies from "js-cookie";
import {ElMessageBox, ElNotification} from "element-plus";
import router from "@/router";
const body = document.getElementsByTagName("body")[0];
const IsWorking = ref(false);
const store = useStore();
const userData = ref({
  Name:"",
  Email:"",
  Password:""
});
const updateAdmin = (payload) => {
  store.dispatch("updateCurrAdmin", payload);
};
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});
async function DoRegister(){
  IsWorking.value=true;
  const response = await fetch('https://inv.tvcnews.co/endPoint/Register.php',{
    method:"POST",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization':'Bearer '
    },
    body:JSON.stringify(userData.value)
  })
  const data = await response.json();
  IsWorking.value=false;
  console.log(data)
  if(data?.status===200){
      Cookies.set('user_token',data.data.token, {expires:30});
    updateAdmin(data?.data?.user);
    await router.push('./dashboard-default')
  }else{
    ElNotification({
      title: 'Warning',
      style:"font-family:tahoma",
      message: data?.message,
      type: 'warning',
    })
  }
}
const callback = async (response) => {
  const result = await fetch("https://inv.tvcnews.co/endPoint/googleLogin.php",{
    method:"POST",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization':'Bearer '
    },
    body:JSON.stringify(response)
  });
  const data = await result.json();
  if(data.status===200){
    Cookies.set('user_token',data.data.token, {expires:30});
    await router.push('./dashboard-default')
  }else{
    await ElMessageBox.alert(data?.message, 'Email error', {
      // autofocus: false,
      showClose:false,
      customStyle:"font-family:tahoma",
      type:"error",
      confirmButtonText: "Ok",
      callback: (action) => {
      },
    })
  }
}
</script>
<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar isBtn="bg-gradient-light" />
      </div>
    </div>
  </div>
  <main class="main-content mt-0" style="font-family: Tahoma">
    <div
      class="page-header align-items-start min-vh-50 pt-5 pb-11 m-3 border-radius-lg"
      style="
        background-image: url(&quot;https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signup-cover.jpg&quot;);
        background-position: top;
      "
    >
      <span class="mask bg-gradient-dark opacity-6"></span>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5 text-center mx-auto">
            <h1 class="text-white mb-2 mt-5" style="direction: rtl">خوش آمدید!</h1>
            <p class="text-lead text-white" style="font-family: Tahoma">
   از  فرم زیر برای ثبت نام استفاده کنید
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
        <div class="col-xl-4 col-lg-5 col-md-7 mx-auto">
          <div class="card z-index-0">
            <div class="card-header text-center pt-4">
              <h5>ثبت نام کنید</h5>
            </div>
            <div class="row px-xl-5 px-sm-4 px-3">
              <div class="col-12 me-auto px-1">
                <GoogleLogin :callback="callback" />
              </div>
              <div class="mt-2 position-relative text-center">
                <p
                  class="text-sm font-weight-bold mb-2 text-secondary text-border d-inline z-index-2 bg-white px-3"
                >
                  و یا
                </p>
              </div>
            </div>
            <div class="card-body">
              <form role="form" style="font-family: Tahoma">
                <argon-input
                    v-model="userData.Name"
                  id="name"
                  type="text"
                  placeholder="نام و نام خانوادگی"
                  aria-label="Name"
                />
                <argon-input
                    v-model="userData.Email"
                  id="email"
                  type="email"
                  placeholder="ایمیل"
                  aria-label="Email"
                />
                <argon-input
                    v-model="userData.Password"
                  id="password"
                  type="password"
                  placeholder="رمز عبور"
                  aria-label="Password"
                />
                <argon-checkbox checked>
                  <label class="form-check-label" for="flexCheckDefault" style="direction: rtl">
                    من
                    <a href="javascript:;" class="text-dark font-weight-bolder"
                      >شرایط و قوانین استفاده از وبسایت</a
                    >
                    می پذیرم
                  </label>
                </argon-checkbox>
                <div class="text-center">
                  <el-button
                      @click="DoRegister"
                      type="primary"
                      size="large"
                      style="width: 150px"
                    class="my-4 mb-2"
                    >ثبت نام</el-button
                  >
                </div>
                <p class="text-sm mt-3 mb-0">
                  آیا قبلا حساب کاربری داشته اید؟
                  <a href="javascript:;" class="text-dark font-weight-bolder"
                    >وارد حساب کاربری شوید</a
                  >
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <app-footer />
</template>
